import 'react-big-calendar/lib/css/react-big-calendar.css'
import './utils/calendar.css';
import { CalendarProvider } from '../../contexts/calendar';
import CalendarPage from './calendar';
import { ClientCardProvider } from '../sales/create/core/clientProvider';
import { ScheduleModalProvider } from './core/ScheduleProvider';
import { ScheduleCardProvider } from './core/ClientScheduleProvider';
import { PeopleProvider } from '../../coreGlobal/providers/PersonProvider';
import { AddressProvider } from '../../coreGlobal/providers/AddressProvider';
import './utils/page.css';

const SchedulePage = () => {
  return (
    <CalendarProvider>
      <ClientCardProvider>
        <ScheduleModalProvider>
          <ScheduleCardProvider>
            <PeopleProvider>
              <AddressProvider>
                <CalendarPage />
              </AddressProvider>
            </PeopleProvider>
          </ScheduleCardProvider>
        </ScheduleModalProvider>
      </ClientCardProvider>
    </CalendarProvider>
  )
}

export default SchedulePage